import { useCallback, useMemo, useState } from 'react';
import { TextField } from "@mui/material";
import { Link, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function validateEmail(mail) {
    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
}

function ChangePass(props) {
  const [text,changeText] = useState("");
  const [heading,changeHeading] = useState("");
  const [open, setOpen] = useState(false);
  const [isLoggedin,changeLog] = useState(false);

  const navigate = useNavigate();

  var style1 = useMemo(()=>{
    return {
      margin:"auto",
      textAlign:"center",
      padding:"15px",
      backgroundColor:props.color,
      width:"fit-content",
      borderRadius:"5px"
    }
  },[props.color]);

  const handleClose = useCallback(() => { 
    if(isLoggedin){
      setOpen(false);
      navigate('/login');
    }
    else setOpen(false);
  },[isLoggedin]);

  var Authenticate = useCallback(()=>{
    let email = document.getElementById("email").value,
    pass1 = document.getElementById("password1").value,
    pass2 = document.getElementById("password2").value;
    let missing = "";
    if(email === "" || pass1 === "" || pass2 === ""){
      if(email === "") missing += "email ";
      if(pass1 === "") missing += "new password ";
      if(pass2 === "") missing += "confirm password ";
      changeText("Please Enter the following fields :\n"+missing);
      changeHeading("Empty Fields not Allowed");
      setOpen(true);
    }
    else if(pass1 !== pass2){
      changeHeading("Password Validation Error");
      changeText("Passwords don't match");
      setOpen(true);
    }
    else if(!validateEmail(email)){
      changeHeading("Invalid Email");
      changeText("Please Enter a valid Email");
      setOpen(true);
    }
    else {
      let config = {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            "X-CSRFToken": props.csrf //TODO: Generate CSRF-Token
          },
          redirect: 'follow',
          referrerPolicy: 'no-referrer',
          body: JSON.stringify({
              email : email,
              password : pass2
          })};
          fetch("passChange",config).then(res=>{
            changeHeading("Server Response CODE : "+res.status.toString());
            if(res.status === 200){
              res.json().then(data =>{ 
                if(data == "Password Changed Sucessfully") changeLog(true);
                changeText(data);
                setOpen(true);
              }).catch(err => { 
                console.info(err); 
                changeText("Invalid Data Received from Server");
                setOpen(true);
              })
            }
            else{
              changeText(res.statusText);
              setOpen(true);
            }
          }).catch(err=>{
              console.info(err);
              changeHeading("Something is not right");
              changeText("There appears to be an error in the server");
              setOpen(true);
          });
      } 
    },[props.csrf]);
  return (
    <>
        <h1 style={{margin:"auto",textAlign:"center"}}><u>Change to your Password</u></h1><br/>
        <div style={style1}>
            <TextField id="email" label="Enter Registered Email" variant="outlined" type={"email"}
            sx={{ input: { color: props.textColor } }}
            InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>
            <TextField id="password1" label="Enter new Password" variant="outlined" type={"password"}
            sx={{ input: { color: props.textColor } }}
            InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>
            <TextField id="password2" label="Confirm new Password" variant="outlined" type={"password"}
            sx={{ input: { color: props.textColor } }}
            InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>
            <Button variant="contained" onClick={Authenticate}>Update Password</Button>
        </div>

        {/*Dialog-Box to display a message*/}
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {heading}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {text}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>OK</Button>
          </DialogActions>
        </Dialog>
        <br/>
        <Link to="/signup" style={{textAlign:"center",display:"block",margin:"auto",color:"white"}}><b>No Account? Create one</b></Link>
    </>
  )
}

export default ChangePass;